/* Urgency Bar — buy-box block behavior.
   deadline: counts down to data-deadline; hides on expiry when
             data-hide-expired is present.
   daily:    counts down to local midnight.
   stock:    shows data-count; with data-animate, decrements by one at a
             random 45-120s interval down to data-floor, persisted per
             session so reloads continue rather than reset. */

if (!window.customElements.get('urgency-bar')) {
  class UrgencyBar extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;

      if (this.mode === 'deadline' || this.mode === 'daily') {
        this.countdownEl = this.querySelector('[data-countdown]');
        this.startCountdown();
      } else if (this.mode === 'stock' && this.hasAttribute('data-animate')) {
        this.startStockAnimation();
      }
    }

    disconnectedCallback() {
      if (this.tick) clearInterval(this.tick);
      if (this.stockTimer) clearTimeout(this.stockTimer);
    }

    /* ── Countdown modes ─────────────────────────────────────────────── */

    target() {
      if (this.mode === 'daily') {
        const midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        return midnight.getTime();
      }
      const parsed = Date.parse(this.dataset.deadline || '');
      return Number.isNaN(parsed) ? null : parsed;
    }

    startCountdown() {
      const targetTime = this.target();
      if (!targetTime || !this.countdownEl) {
        if (this.hasAttribute('data-hide-expired')) this.hidden = true;
        return;
      }

      const render = () => {
        let remaining = Math.floor((targetTime - Date.now()) / 1000);

        if (remaining <= 0) {
          if (this.hasAttribute('data-hide-expired')) {
            this.hidden = true;
          } else {
            this.countdownEl.textContent = '00:00:00';
          }
          clearInterval(this.tick);
          return;
        }

        const days = Math.floor(remaining / 86400);
        remaining -= days * 86400;
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        const pad = (n) => String(n).padStart(2, '0');
        const clock = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        this.countdownEl.textContent = days > 0 ? `${days}d ${clock}` : clock;
      };

      render();
      this.tick = setInterval(render, 1000);
    }

    /* ── Animated stock mode ─────────────────────────────────────────── */

    startStockAnimation() {
      this.display = this.querySelector('[data-count-display]');
      if (!this.display) return;

      this.bar = this.querySelector('[data-stock-bar]');
      const floor = parseInt(this.dataset.floor, 10) || 3;
      const start = parseInt(this.dataset.count, 10) || floor;
      const max = Math.max(parseInt(this.dataset.max, 10) || start, start);
      this.renderBar = (n) => {
        if (this.bar) this.bar.style.width = `${(n / max) * 100}%`;
      };
      const key = this.dataset.key || 'urgency-bar';

      let count = start;
      try {
        const stored = parseInt(sessionStorage.getItem(key), 10);
        if (!Number.isNaN(stored)) count = Math.min(stored, start);
      } catch (e) { /* private browsing */ }

      count = Math.max(count, floor);
      this.display.textContent = count;
      this.renderBar(count);

      const schedule = () => {
        if (count <= floor) return;
        const delay = 45000 + Math.random() * 75000;
        this.stockTimer = setTimeout(() => {
          count -= 1;
          this.display.textContent = count;
          this.renderBar(count);
          try { sessionStorage.setItem(key, String(count)); } catch (e) {}
          schedule();
        }, delay);
      };
      schedule();
    }
  }

  window.customElements.define('urgency-bar', UrgencyBar);
}
